// import Toaster from 'toastr';
// import Messages from '../configurations/messages';
// import * as types from './actionTypes';
// import UserApi from '../api/UserApi';
// import { permissionsObject } from '../configurations/permissions';
// const permissionsObj = permissionsObject;


// export function loadUserPermissionsSuccess(permissions) {
//     return { type: types.LOAD_USER_PERMISSIONS_SUCCESS, permissions };
// }

// export function loadUserPermissions() {
//     return function (dispatch) {

//         return UserApi.getUserPermissions()
//         .then(response => {
//             let permissions = response.data.map(auth => {
//                 return auth.authority;
//              });
//             dispatch(loadUserPermissionsSuccess(permissions));
//         }).catch(error => {
//              let permissions = Object.values(permissionsObj);
//             dispatch(loadUserPermissionsSuccess(permissions));

//             Toaster.error(Messages.LOAD_PERMISSIONS_ERROR);
//             dispatch(loadUserPermissionsSuccess([]));
//         });
//     };
// }

import Toaster from "toastr";
import Messages from "../configurations/messages";
import UserApi from "../api/UserApi";
import * as types from "./actionTypes";
import { permissionsObject } from "../configurations/permissions";
const permissionsObj = permissionsObject;

export function loadUserPermissionsSuccess(permissions) {
  return { type: types.LOAD_USER_PERMISSIONS_SUCCESS, permissions };
}

export function loadUserPermissions() {
  return function (dispatch) {
    let permissions = Object.values(permissionsObj);
    // return dispatch(loadUserPermissionsSuccess(permissions));
    return UserApi.getUserPermissions()
      .then((response) => {
        let permissions = response.data.map((auth) => {
          return auth.authority;
        });
        dispatch(loadUserPermissionsSuccess(permissions));
      })
      .catch((error) => {
        Toaster.error(Messages.LOAD_PERMISSIONS_ERROR);
        dispatch(loadUserPermissionsSuccess(permissions));

        // dispatch(loadUserPermissionsSuccess([]));
      });
  };
}


// WEBPACK FOOTER //
// ./src/actions/permissionsAction.js